module.exports = __webpack_public_path__ + "static/lahli-logo-63fa330c4089f996ac8f5bc5197f1f61.svg";